<template>
  <form action="#" class="auth-form" @submit.prevent="handleLogin">
    <VFormInput
      inputType="email"
      label="Email"
      placeholder="Enter your email address"
      :leftIcon="true"
      :error="errors.email"
      @update="val => handleInput('email', val)"
    >
      <template #left>
        <VSvgIcon name="email" />
      </template>
    </VFormInput>

    <VFormInput
      :inputType="show ? 'text' : 'password'"
      label="Password"
      placeholder="Password"
      :leftIcon="true"
      :rightIcon="true"
      :error="errors.password"
      @update="val => handleInput('password', val)"
    >
      <template #left>
        <VSvgIcon name="lock" />
      </template>
      <template #right>
        <span @click="handleClickIcon">
          <VSvgIcon v-if="!show" name="eye-off" />
          <VSvgIcon v-if="show" name="eye" />
        </span>
      </template>
    </VFormInput>

    <!-- this is the only section that isn't shared between customer and admin -->
    <div v-if="!isAdmin" class="auth-form-options">
      <div class="auth-form-options-field">
        <label class="auth-form-options-field-label" for="remember">Remember Me</label>
        <input type="checkbox" id="remember" name="remember" value="true" />
      </div>
      <div class="auth-form-options-field">
        <router-link class="text-xs text-ricoma-orange-200" to="/auth/password/request">
          Forgot password?
        </router-link>
      </div>
    </div>

    <button class="auth-form-button mb-0" type="submit" :disabled="formLoading">
      <BeatLoader
        v-if="formLoading"
        color="#FAFAFA"
        :size="0.875"
        sizeUnit="rem"
        class="flex items-center"
      />
      <span v-else>Sign in</span>
    </button>
  </form>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';

/*import { launchNotification } from '@/utils/launchNotification';*/

import VSvgIcon from '@/components/base/VSvgIcon';
import VFormInput from '@/components/base/VFormInput';

import { formMixin } from '@/mixins';

export default {
  name: 'LoginForm',
  components: { VSvgIcon, BeatLoader, VFormInput },
  props: {
    isAdmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    onSubmit: {
      type: Function,
      required: true,
    },
  },
  mixins: [formMixin({ email: '', password: '' })],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    handleClickIcon() {
      this.show = !this.show;
    },
    handleInput(name, val) {
      this.handleResetError(name);
      this.handleSetField(name, val);
    },
    async handleLogin() {
      try {
        await this.handleSubmit(this.onSubmit)();
      } catch (error) {
        this.formLoading = false;

        if (error && error.response && error.response.status && error.response.status === 401) {
          return this.$notify({
            group: 'error',
            type: 'error',
            title: 'Unauthorized request',
            text: 'Wrong email or password.',
          });
        }
        console.log(error);
        return this.$notify({
          group: 'error',
          type: 'error',
          title: 'Fail request',
          text: error && error.message ? error.message : 'Something was wrong. try again',
        });
      }
    },
  },
};
</script>
